import { API } from "@/App";
import { toast } from "sonner";

export async function apiCall(path, { method = "GET", body } = {}) {
  const res = await fetch(`${API}${path}`, {
    method,
    headers: { "Content-Type": "application/json" },
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = {};
  try { data = await res.json(); } catch { /* ignore */ }
  if (!res.ok || data.success === false) {
    const msg = data.detail || data.message || "Request failed";
    throw new Error(typeof msg === "string" ? msg : "Request failed");
  }
  return data;
}

export function copyText(text, label = "Copied") {
  try {
    navigator.clipboard.writeText(text);
    toast.success(`${label}: ${text}`);
  } catch {
    toast.message(`${label}: ${text}`);
  }
}
